import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Production: Subdomain root (admin.wellbeingai.soulintoit.com/)
// Development: Path-based (/admin/ on localhost:5174)
const basename = import.meta.env.PROD ? '/' : '/admin';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter basename={basename}>
            <App />
        </BrowserRouter>
    </StrictMode>,
)